var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpainFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 32,
  width: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#c60a1d",
  d: "M32 24a3.556 3.556 0 0 1-3.556 3.556H3.556A3.556 3.556 0 0 1 0 24V8a3.556 3.556 0 0 1 3.556-3.556h24.888A3.556 3.556 0 0 1 32 8v16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffc400",
  d: "M0 10.667h32v10.666H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ea596e",
  d: "M8 15.111v2.667a2.667 2.667 0 1 0 5.333 0V15.11H8z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4a2b2",
  d: "M10.667 14.222h2.666v2.667h-2.666z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#dd2e44",
  d: "M8 14.222h2.667v2.667H8z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ea596e",
  d: "M8 12.889a2.667 1.333 0 1 0 5.333 0 2.667 1.333 0 1 0-5.333 0"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffac33",
  d: "M8 12.222a2.667.667 0 1 0 5.333 0 2.667.667 0 1 0-5.333 0"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#99aab5",
  d: "M6.222 14.222h.89v6.222h-.89zm8 0h.89v6.222h-.89z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#66757f",
  d: "M5.333 19.556H8v.888H5.333zm8 0H16v.888h-2.667zm-7.11-6.223h.888v.89h-.889zm8 0h.888v.89h-.889z"
})));
export default SvgSpainFlag;